import React from "react";
import { connect } from 'react-redux';
import TicketsTableForManager from './TicketsTableForManager';
import Close from "@material-ui/icons/Close";

class TicketsListModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        //this.wrapperRef = React.createRef();
        //this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        //document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        //document.removeEventListener("mousedown", this.handleClickOutside);
    }

    //handleClickOutside(event) {
    //    const
    //        {
    //            onClose
    //        } = this.props;

    //    if (this.wrapperRef) {
    //        if (!this.wrapperRef.current.contains(event.target)) {
    //            onClose();
    //        }
    //    }
    //}

    render() {
        const {
            allInteractions,
            allInteractionCount,
            onClose,
            isQaTickets,
            goToAudit,
            onSelectNewTimeRange,
            calibratedOnSurveyQuestions,
            onDownloadReport,
            fromDate,
            toDate,
        } = this.props;

        return (<div className="modal displayBlock" >
            <div className="modal-content" style={{ marginTop: '-83px' }}>
                <div className="flex flex-flex-end"><Close className="cursor-pointer" onClick={() => onClose()} /></div>
                <TicketsTableForManager
                    fromDate={fromDate}
                    toDate={toDate}
                    onDownloadReport={onDownloadReport}
                    calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                    onSelectNewTimeRange={onSelectNewTimeRange}
                    goToAudit={goToAudit}
                    isQaTickets={isQaTickets}
                    interactionToShow={allInteractions}
                    allInteractionCount={allInteractionCount} />
            </div>
        </div>);
    };
}

const select = state => ({});

export default connect(select)(TicketsListModal);

